<template>
  <div>
    <div class="grid gap3 form-row">
      <FormInput
        class="grid-col-4"
        id="gender"
        type="radio"
        label="TITLE"
        v-model:value="modelValue.gender"
        v-model:errorMessage="errors.gender"
        :options="[
          { value: 'mr', text: 'Monsieur' },
          { value: 'mme', text: 'Madame' }
        ]"
      />

      <FormInput
        class="grid-col-2"
        id="firstname"
        type="text"
        label="FIRST_NAME"
        placeholder="FIRST_NAME_PLACEHOLDER"
        v-model:value="modelValue.firstname"
        v-model:errorMessage="errors.firstname"
      />

      <FormInput
        class="grid-col-2"
        id="lastname"
        type="text"
        label="LAST_NAME"
        placeholder="LAST_NAME_PLACEHOLDER"
        v-model:value="modelValue.lastname"
        v-model:errorMessage="errors.lastname"
      />

      <FormInput
        class="grid-col-2"
        id="birth_date"
        type="text"
        label="BIRTH_DATE"
        placeholder="Ex: 27/03/1980"
        mask="##/##/####"
        v-model:value="modelValue.birth_date"
        v-model:errorMessage="errors.birth_date"
      />

      <FormInput
        class="grid-col-2"
        id="nationality"
        type="select"
        label="NATIONALITY"
        placeholder="Nationalité du proche"
        v-model:value="modelValue.nationality"
        v-model:errorMessage="errors.nationality"
        :options="countryOptions"
      />

      <FormInput
        class="grid-col-4"
        id="email"
        type="text"
        label="EMAIL"
        placeholder="PLACEHOLDER_RELATIVE_EMAIL"
        v-model:value="modelValue.email"
        v-model:errorMessage="errors.email"
      />
    </div>

    <div class="py3">
      <div class="flex justify-between col-12 xs-hide sm-hide gap1">
        <ButtonV2 color="red" :action="showDeleteModal" :reference="'DELETE'" rounded class="col-4 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="light" :action="resetForm" :reference="'CANCEL'" rounded class="col-4 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="dark" :action="saveForm" :reference="'SAVE'" rounded class="col-4 py1" />
      </div>
      <div class="flex flex-column justify-between col-12 gap1 md-hide lg-hide">
        <ButtonV2 color="red" :action="showDeleteModal" :reference="'DELETE'" rounded class="col-12 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="light" :action="resetForm" :reference="'CANCEL'" rounded class="col-12 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="dark" :action="saveForm" :reference="'SAVE'" rounded class="col-12 py1" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { isEqual } from 'lodash';
import { useStore } from 'vuex'
import FormInput from '@/components/inputs/FormInput';
import ButtonV2 from '@/components/elements/ButtonV2';
import { getReferencelabel, countryOptions } from '@/mixins/utils';
import { validateForm } from '@/mixins/formValidation';

export default {
  name: 'ContactForm',
  components: { FormInput, ButtonV2 },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['save-form', 'reset-form', 'open-delete-contact-modal'],

  setup(props, { emit }) {
    const store = useStore();
    const errors = ref({});

    const contact = computed(() => store.state.contacts.find(u => u.uuid === props.modelValue.uuid) || {});

    const contactFormValidations = {
      gender: {
        rules: ['required'],
        errorMessages: {
          required: 'ERROR_REQUIRED'
        }
      },
      firstname: {
        rules: ['required', 'min:2'],
        regex: /^([A-Za-z-'\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/,
        errorMessages: {
          required: 'FIRST_NAME_ERROR',
          min: 'FIRST_NAME_MORE_2',
          regex: 'FIRST_NAME_ONLY_LETTERS'
        }
      },
      lastname: {
        rules: ['required', 'min:2'],
        regex: /^([A-Za-z-'\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/,
        errorMessages: {
          required: 'LASTNAME_ERROR',
          min: 'LASTNAME_MORE_2',
          regex: 'LASTNAME_ONLY_LETTERS'
        }
      },
      birth_date: {
        rules: ['required', 'min_age:1,dd/MM/yyyy', 'max_age:100,dd/MM/yyyy'],
        errorMessages: {
          required: 'ERROR_BIRTH_DATE',
          min_age: 'ERROR_BIRTH_DATE_MIN_AGE_1',
          max_age: 'ERROR_BIRTH_DATE_MAX_AGE_100'
        }
      },
      nationality: {
        rules: ['required'],
        errorMessages: {
          required: 'ERROR_REQUIRED'
        }
      },
      email: {
        rules: ['required', 'email'],
        errorMessages: {
          required: 'ERROR_EMAIL_EMPTY',
          email: 'ERROR_WRONG_EMAIL'
        }
      }
    };

    const disableFormButtons = computed(() => isEqual(contact.value, props.modelValue))

    const saveForm = () => {
      if (disableFormButtons.value) {
        return;
      }

      errors.value = validateForm(props.modelValue, contactFormValidations);

      if (Object.keys(errors.value).length) {
        return;
      }

      emit('save-form');
    };

    const resetForm = () => {
      if (disableFormButtons.value) {
        return;
      }

      errors.value = {};
      emit('reset-form');
    };

    const showDeleteModal = () => {
      emit('open-delete-contact-modal');
    };

    return {
      errors,
      countryOptions,
      getReferencelabel,
      saveForm,
      resetForm,
      showDeleteModal,
      disableFormButtons,
      emit
    };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}
</style>